export default __webpack_public_path__ + "static/swvl-client-image-1-ba944099238a827f161f1fdb928f44f4.webp";